import React, { useMemo } from 'react'
import { Tabs, Tab } from '@fs/zion-ui'
import { useLocation } from '@fs/zion-router'
import { useTranslation } from 'react-i18next'
import useAppTabs from '../hooks/useAppTabs'

const AppTabs = ({ showAdmin, showReports, showLabs }) => {
  const [t] = useTranslation()
  const { currentTabIndex, showTabs, visibleTabs } = useAppTabs({ showAdmin, showReports, showLabs })
  const { pathname } = useLocation()
  const isVerifyPlaces = pathname.includes('verify-places')
  const isRecordHints = pathname.includes('record-hints')

  const visibleTabsArray = useMemo(() => visibleTabs.map((tab) => tab.path), [visibleTabs])

  const tabs = useMemo(
    () => [
      {
        to: '/',
        id: 'overview',
        linkName: 'overview',
        title: t('v2_tabs_overview'),
        dataTestId: 'tablist-tab-overview',
        show: visibleTabsArray.includes('/'),
      },
      {
        to: '/opportunities',
        id: 'opportunities',
        linkName: 'opportunities',
        title: t('v2_tabs_opportunities', 'Opportunities'),
        dataTestId: 'tablist-tab-opportunities',
        show: visibleTabsArray.includes('/opportunities'),
      },
      {
        to: '/your-impact',
        id: 'impact',
        linkName: 'impact',
        title: t('v2-tabs-your-impact', 'Your Impact'),
        dataTestId: 'tablist-tab-impact',
        show: visibleTabsArray.includes('/your-impact'),
      },
      {
        to: '/indexing',
        id: 'indexing',
        linkName: 'indexing',
        title: t('v2_tabs_indexing', 'What Is Indexing?'),
        dataTestId: 'tablist-tab-indexing',
        show: visibleTabsArray.includes('/indexing'),
      },
      {
        to: '/reports',
        id: 'reports',
        linkName: 'reports',
        title: t('reports.tab-heading', 'Reports'),
        dataTestId: 'tablist-tab-reports',
        show: showReports,
      },
      {
        to: '/prison-reports',
        id: 'prison-reports',
        linkName: 'prison-reports',
        title: t('prison-reports.tab-heading', 'Prison Reports'),
        dataTestId: 'tablist-tab-prison-reports',
        show: visibleTabsArray.includes('/prison-reports'),
      },
      {
        to: '/admin',
        id: 'admin',
        linkName: 'admin-console',
        title: t('admin.tab-heading', 'Admin Console'),
        dataTestId: 'tablist-tab-admin',
        show: showAdmin,
      },
      {
        to: '/labs',
        id: 'labs',
        linkName: 'give-labs',
        title: t('labs.tab-heading', 'GIVE Labs'),
        dataTestId: 'tablist-tab-labs',
        show: showLabs,
      },
    ],
    [t, showAdmin, showLabs, showReports, visibleTabsArray]
  )

  if (!showTabs || isVerifyPlaces || isRecordHints) {
    return null
  }

  return (
    <Tabs index={currentTabIndex} data-testid="tablist">
      {tabs
        .filter((tab) => tab.show)
        .map((tab) => (
          <Tab key={tab.id} to={tab.to} linkName={tab.linkName} title={tab.title} data-testid={tab.dataTestId} />
        ))}
    </Tabs>
  )
}

export default AppTabs
